import { Navigate, useLocation } from 'react-router-dom';
import { SignInCard } from '@kawai/auth-bootstrap';
import { useAuth } from '../lib/auth.js';
import { impersonationFailureMessage } from '../lib/impersonationConsume.js';
import { getFeatureUrl } from '../lib/featureUrls.js';
import { ROUTES } from '../routes.js';

interface LocationState {
  from?: string;
}

/**
 * S-89: フォーム本体は @kawai/auth-bootstrap の SignInCard に共通化。
 * ここは signed-in 時の遷移（fromPath）と、S-07b の impersonation 失敗警告
 * （notice slot 注入）のみを担う。S-136: 見た目は v2（SignInCard variant / 警告は warning の面）。
 */
export function SignInPage() {
  const { status, signIn, impersonationFailure } = useAuth();
  const location = useLocation();
  const fromPath = (location.state as LocationState | null)?.from ?? ROUTES.home;

  if (status === 'signed-in') {
    return <Navigate to={fromPath} replace />;
  }

  return (
    <SignInCard
      logoSrc="/brand/tracepit-logo.png"
      tenantName="セルフ武生21SS"
      appTitle="テナントポータル"
      contactEmail="info@tracepit.jp"
      signIn={signIn}
      variant="v2"
      notice={
        impersonationFailure && (
          <div
            role="alert"
            className="mt-4 rounded-lg bg-warning-tint px-[18px] py-3 text-label text-warning-ink"
          >
            <p className="font-medium">impersonation セッションを開始できませんでした</p>
            <p className="mt-1">{impersonationFailureMessage(impersonationFailure)}</p>
            <a
              href={getFeatureUrl('saas-admin')}
              className="mt-2 inline-flex items-center justify-center rounded-lg bg-brand px-4 py-1.5 text-label font-medium text-white hover:opacity-90"
            >
              saas-admin に戻る
            </a>
          </div>
        )
      }
    />
  );
}
